import { SimpleTextParagraph } from 'app/src/shared/components'
import { useTranslation } from 'react-i18next'

export function SuggestSection() {
  const { t } = useTranslation('proposal', { keyPrefix: 'Proposal.SuggestSection' })
  return <SimpleTextParagraph txt={t('Text')} />
}
